import { render, staticRenderFns } from "./ResendTimer.vue?vue&type=template&id=def09ab4&lang=pug"
import script from "./ResendTimer.vue?vue&type=script&lang=js"
export * from "./ResendTimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports